var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('div',{staticClass:"w-full max-w-2xl mx-auto mt-5"},[_c('div',{staticClass:"flex flex-auto justify-evenly border rounded-md w-full"},[_c('button',{class:[
          { 'colorActivo': _vm.isActive === 1 },
          'px-2 py-1 rounded-md w-full boton'
        ],on:{"click":function($event){_vm.isActive = 1}}},[_c('i',{staticClass:"fa-solid fa-paperclip"}),_vm._v(" Generador de links\n      ")]),_c('button',{class:[
          { 'colorActivo': _vm.isActive === 2 },
          'px-2 py-1 rounded-md w-full boton'
        ],on:{"click":function($event){_vm.isActive = 2}}},[_vm._v("\n      Listado de links acortados\n      ")])])]),(_vm.isActive === 1)?_c('div',[_c('AcortadorCrearVue',{staticClass:"mt-2"})],1):_vm._e(),(_vm.isActive === 2)?_c('div',[_c('listadoAcortadorVue',{staticClass:"mt-4"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }